import { startDateState } from '@/pages/orders/personalOrder/config/selectOptions'
import { limitMoreZero } from '@/utils/validate'


const timeType = {
  1: '每日',
  2: '每周',
  3: '每月',
}

const timeTypeENUM = {
  DAY: 1,
  WEEK: 2,
  MONTH: 3,
}

const config = function () {
  return {
    transferList: [
      {
        el: 'input',
        itemConfig: {
          label: '规则名称',
          prop: 'ruleName',
        },
        elConfig: {
          placeholder: '请输入最长20个字',
          maxlength: 20,
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '转出方',
          prop: 'transferorId',
        },
        elConfig: {
          placeholder: '请选择',
          options: {
            label: 'accountName',
            value: 'accountId',
            list: [],
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '接收方',
          prop: 'receiverId',
        },
        elConfig: {
          placeholder: '请选择',
          options: {
            label: 'accountName',
            value: 'accountId',
            list: [],
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '转账类型',
          prop: 'timeType',
        },
        elConfig: {
          placeholder: '请选择',
          options: {
            label: 'label',
            value: 'value',
            list: this.dictParseList(timeType),
          },
          events: {
            change: (type) => {
              this.model.timeList = []
              this.setTimeList(type)
            },
          },
        },
      },
      {
        el: 'select',
        itemConfig: {
          label: '日期',
          prop: 'timeList',
        },
        elConfig: {
          placeholder: '请选择',
          options: {
            label: 'label',
            value: 'value',
            list: this.dictParseList(startDateState),
          },
          multiple: true,
          'collapse-tags': true,
        },
        isShow: false,
      },
      {
        el: 'input',
        itemConfig: {
          label: '单次转账金额',
          prop: 'divideAmount',
        },
        elConfig: {
          placeholder: '请输入',
          events: {
            input: (newValue) => {
              limitMoreZero(newValue, (e) => {
                this.model.divideAmount = e
              }, 7)
            },
          },
          slotRender: (createElement) => {
            return createElement('span', {
              slot: 'suffix',
            }, '元')
          },
        },
      },
    ],
    transferRules: {
      ruleName: [
        {
          required: true,
          message: '必填项，请填写',
          trigger: 'change',
        },
      ],
      transferorId: [
        {
          required: true,
          message: '必填项，请选择',
          trigger: 'change',
        },
      ],
      receiverId: [
        {
          required: true,
          message: '必填项，请选择',
          trigger: 'change',
        },
      ],
      timeType: [
        {
          required: true,
          message: '必填项，请选择',
          trigger: 'change',
        },
      ],
      divideAmount: [
        {
          required: true,
          message: '必填项，请填写',
          trigger: 'change',
        },
        { validator: (_, value, callback) => {
          if (Number(value) === 0) {
            callback(new Error('金额不能为0'))
          }
          callback()
        },
        trigger: ['blur'] },
      ],
      timeList: [
        {
          required: false,
          message: '必填项，请选择',
          trigger: 'change',
        },
      ],
    },
  }
}

export { timeTypeENUM, config }
